var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isFunctionShown(_vm.funcId))?_c('el-button',{ref:"input",attrs:{"disabled":_vm.disabled || _vm.$isFunctionDisabled(_vm.funcId),"icon":_vm.icon,"plain":_vm.plain,"size":_vm.size,"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }